export default function cc(...obj) {
    return obj.filter(c => c).join(" ");
  }